import { AddIcon, Flex } from "@fluentui/react-northstar";
import React from "react";
import { Container } from "../../../../common/styles";
import { SubTitle, Title } from "../../components/Header";
import styled from "styled-components";
import NavCategory from "../../components/nav_list/NavCategory";
import { Outlet, useLocation } from "react-router-dom";
import {
    ClockFilled,
    DocumentHeartFilled,
    FolderPersonFilled,
    GlobeFilled,
    PaymentFilled,
} from "@fluentui/react-icons";
import useLogicDocumentHrOutlet from "../../hooks/useLogicDocumentHrOutlet";
import withRole from "../../../../HOC/withRole";
import { ROLES_CODE } from "../../../../constants/roles";

export const NAVLIST_CATEGORY = {
    expenses: "expenses",
    hr_document: "hr_documents",
    time_reporting: "timesheet",
    leave_proof: "leave",
    common_documents: "common_documents",
};

const HrDocumentsSocietyOutlet = () => {
    const {
        isActiveCommonDocuments,
        isActiveExpenses,
        isActiveFolderHr,
        isActiveLeave,
        isActiveTimesheet,
    } = useLogicDocumentHrOutlet();

    return (
        <Flex column style={{ backgroundColor: "#f5f5f5", height: "100vh" }}>
            <Flex column gap="gap.medium">
                <Container
                    column
                    gap="gap.smaller"
                    style={{ marginTop: "20px" }}
                >
                    {/* header */}
                    <Flex column gap="gap.smaller">
                        <Title>Documents de l'entreprise</Title>
                        <SubTitle>
                            Retrouvez ici tous les documents présents dans
                            Yeetch
                        </SubTitle>
                    </Flex>
                    {/* body */}
                    <BodyContainer fill>
                        <LeftPanel>
                            <Flex>
                                <LeftPanelTitle>Catégories</LeftPanelTitle>
                            </Flex>
                            <Flex column gap="gap.medium">
                                <NavCategory
                                    icon={
                                        <FolderPersonFilled
                                            fontSize={20}
                                            color={
                                                isActiveFolderHr
                                                    ? "var(--color-primary)"
                                                    : "inherit"
                                            }
                                        />
                                    }
                                    title={"Dossiers RH"}
                                    active={isActiveFolderHr}
                                    keyNavigateTo={NAVLIST_CATEGORY.hr_document}
                                />
                                <NavCategory
                                    icon={
                                        <PaymentFilled
                                            fontSize={20}
                                            color={
                                                isActiveExpenses
                                                    ? "var(--color-primary)"
                                                    : "inherit"
                                            }
                                        />
                                    }
                                    title={"Notes de frais"}
                                    active={isActiveExpenses}
                                    keyNavigateTo={NAVLIST_CATEGORY.expenses}
                                />
                                <NavCategory
                                    icon={
                                        <ClockFilled
                                            fontSize={20}
                                            color={
                                                isActiveTimesheet
                                                    ? "var(--color-primary)"
                                                    : "inherit"
                                            }
                                        />
                                    }
                                    title={"Feuilles de temps"}
                                    keyNavigateTo={
                                        NAVLIST_CATEGORY.time_reporting
                                    }
                                    active={isActiveTimesheet}
                                />
                                <NavCategory
                                    icon={
                                        <DocumentHeartFilled
                                            fontSize={20}
                                            color={
                                                isActiveLeave
                                                    ? "var(--color-primary)"
                                                    : "inherit"
                                            }
                                        />
                                    }
                                    title={"Justificatifs absence"}
                                    keyNavigateTo={NAVLIST_CATEGORY.leave_proof}
                                    active={isActiveLeave}
                                />
                                <NavCategory
                                    icon={
                                        <GlobeFilled
                                            fontSize={20}
                                            color={
                                                isActiveCommonDocuments
                                                    ? "var(--color-primary)"
                                                    : "inherit"
                                            }
                                        />
                                    }
                                    title={"Documents communs"}
                                    keyNavigateTo={
                                        NAVLIST_CATEGORY.common_documents
                                    }
                                    active={isActiveCommonDocuments}
                                />
                            </Flex>
                        </LeftPanel>
                        <RightPanel fill>
                            <Outlet />
                        </RightPanel>
                    </BodyContainer>
                </Container>
            </Flex>
        </Flex>
    );
};

export default withRole([ROLES_CODE.hr])(HrDocumentsSocietyOutlet);

export const LeftPanelTitle = styled(Flex)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
`;

export const LeftPanel = styled(Flex)`
    display: flex;
    width: 251px;
    height: 100%;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
`;

export const RightPanel = styled(Flex)`
    padding: 24px 32px 13px 40px;
`;

export const BodyContainer = styled(Flex)`
    border-radius: 8px;
    background: #fff;
    height: 620px;
    /* shadow-4 */
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;
